import { SKRFraga } from "@/types/skr";

export const skrFragorData: SKRFraga[] = [
  // Storlek
  {
    id: "storlek-byggtid",
    text: "Hur lång är projektets beräknade totala byggtid?",
    kategori: "Storlek",
    hjalptext: "Låg: <6 månader, Medel: 6-24 månader, Hög: >24 månader"
  },
  {
    id: "storlek-personer",
    text: "Hur många personer kommer arbeta samtidigt i byggskedet?",
    kategori: "Storlek",
    hjalptext: "Låg: <15 personer, Medel: 15-50 personer, Hög: >50 personer"
  },
  {
    id: "storlek-persondagar",
    text: "Uppskattat antal persondagar totalt? (Gräns: >500 kräver förhandsanmälan)",
    kategori: "Storlek",
    hjalptext: "Låg: <500, Medel: 500-5000, Hög: >5000"
  },
  {
    id: "storlek-entreprenorer",
    text: "Antal olika entreprenörer/projektörer involverade?",
    kategori: "Storlek",
    hjalptext: "Låg: 1-3, Medel: 4-15, Hög: >15"
  },
  {
    id: "storlek-etablering",
    text: "Är etablering och logistik en utmaning?",
    kategori: "Storlek",
    hjalptext: "Bedöm utifrån tillgänglighet, transport, uppställningsytor"
  },

  // Komplexitet
  {
    id: "komplexitet-teknisk",
    text: "Innehåller projektet tekniskt komplicerade moment (t.ex. installationer, specialkonstruktioner)?",
    kategori: "Komplexitet",
    hjalptext: "Bedöm teknisk svårighetsgrad och specialistkrav"
  },
  {
    id: "komplexitet-samverkande",
    text: "Flera projektörer eller samverkande konstruktioner (t.ex. stål/betong)?",
    kategori: "Komplexitet",
    hjalptext: "Bedöm samordningskomplexitet mellan olika konstruktionstyper"
  },
  {
    id: "komplexitet-samtidiga",
    text: "Samtidiga arbeten, trånga ytor eller ombyggnad i befintlig miljö?",
    kategori: "Komplexitet",
    hjalptext: "Bedöm arbetsmiljöutmaningar och samordningssvårigheter"
  },
  {
    id: "komplexitet-pagaende",
    text: "Ska verksamhet pågå parallellt med byggnation (t.ex. sjukhus, skola)?",
    kategori: "Komplexitet",
    hjalptext: "Bedöm påverkan på pågående verksamhet"
  },
  {
    id: "komplexitet-andra",
    text: "Behöver lösningar samordnas med andra byggherrar/verksamheter?",
    kategori: "Komplexitet",
    hjalptext: "Bedöm extern samordningskomplexitet"
  },
  {
    id: "komplexitet-tidsplan",
    text: "Finns risker kopplade till tidsplanen (t.ex. för snäva tidsramar, parallella arbeten eller brist på tid för säkerhetsåtgärder)?",
    kategori: "Komplexitet",
    hjalptext: "Bedöm tidsplanens påverkan på arbetsmiljön, stress och säkerhetsåtgärder"
  },
  {
    id: "komplexitet-kommunikation",
    text: "Finns risk för bristande kommunikation eller otydliga ansvarsgränser mellan aktörer?",
    kategori: "Komplexitet",
    hjalptext: "Bedöm kommunikationsrisker och ansvarsgränser mellan olika aktörer"
  },
  {
    id: "komplexitet-forandringar",
    text: "Finns rutiner för att hantera förändringar i projektet (t.ex. nya aktörer, ändrade metoder, ändrad tidplan)?",
    kategori: "Komplexitet",
    hjalptext: "Bedöm hur väl projektorganisationen hanterar oförutsedda ändringar"
  },

  // Risknivå
  {
    id: "risk-sarskilda",
    text: "Förekommer arbeten med särskild risk (enl. AFS 2023:3 kap. 11 §12)? Exempel: arbete på hög höjd, kemikalier, rivning, sprängning, mm.",
    kategori: "Risknivå",
    hjalptext: "Bedöm förekomst av högriskarbeten enligt AFS"
  },
  {
    id: "risk-samordning",
    text: "Risk för samordningsproblem mellan aktörer på plats?",
    kategori: "Risknivå",
    hjalptext: "Bedöm risker för krockar mellan olika arbetsgrupper"
  },
  {
    id: "risk-yttre",
    text: "Finns yttre riskfaktorer (trafik, väder, höjd, vatten, spår)?",
    kategori: "Risknivå",
    hjalptext: "Bedöm externa risker som påverkar arbetsmiljön"
  },
  {
    id: "risk-projektering",
    text: "Behöver vissa arbetsmiljöfrågor hanteras särskilt i projekteringen (AFS 2023:3 kap. 9–10)?",
    kategori: "Risknivå",
    hjalptext: "Bedöm behov av särskild arbetsmiljöprojektering"
  },
  {
    id: "risk-nya-metoder",
    text: "Används nya eller oprövade metoder, tekniker eller material som kan innebära särskilda risker?",
    kategori: "Risknivå",
    hjalptext: "Bedöm okända risker med nya material, metoder eller tekniker"
  },
  {
    id: "risk-arbetsbelastning",
    text: "Finns risk för hög arbetsbelastning, stress eller bristande återhämtning under projektets gång?",
    kategori: "Risknivå",
    hjalptext: "Bedöm psykosocial arbetsmiljö och risk för utmattning"
  },

  // Förväntad åtgärdsnivå
  {
    id: "atgard-bas",
    text: "Kommer projektet kräva: Byggherren utser Bas-P/Bas-U",
    kategori: "Förväntad åtgärdsnivå",
    hjalptext: "Bedöm om BAS-P/BAS-U krävs enligt regelverket"
  },
  {
    id: "atgard-amp",
    text: "Kommer projektet kräva: Arbetsmiljöplan (enligt kap. 11)",
    kategori: "Förväntad åtgärdsnivå",
    hjalptext: "Bedöm om arbetsmiljöplan krävs"
  },
  {
    id: "atgard-dokumentation",
    text: "Kommer projektet kräva: Dokumentation för bruksskedet (kap. 10)?",
    kategori: "Förväntad åtgärdsnivå",
    hjalptext: "Bedöm om dokumentation för bruksskedet krävs"
  }
];